export const authGuard = (to, from, next) => {
  return next();
};
